import RetrievalTest from "../Components/RetrievalTest/RetrievalTest";

const RetrievalTestPage = () => {
  return <RetrievalTest />;
};

export default RetrievalTestPage;
